/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
const query = graphql`
query AccountActivationFetchQuery($accountId: UUID!) {
    onboardingAccountTByAccountId(accountId: $accountId) {
        onboardingId
        onboardingStatus
        onboardingAccountStepTsByOnboardingAid(condition: {stepAction: 2}) {
            totalCount
            nodes {
                onboardingAstepId
                stepStatus
            }
        }
        accountTByAccountId {
            accountDelegatedAuthsTsByAccountId(condition: {appName:"FreshBooks"}) {
                totalCount
            }
        }
    }
}
`;

function fetch(accountId) {
  const variables = {
      accountId: accountId
  }

  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}

export default { fetch };